<template>
  <div>
    <div v-if="dialog_count == 1">
      <v-card v-if="renderComponent" class="pt-1 mt-0" flat>
        <v-row v-if="dialog_count == 1">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card class="mr-5 ml-6" elevation="1">
              <v-alert
                rounded
                color="white"
                height="60px"
                width="620px"
                v-model="alert"
                dismissible
                style="margin-left: 360px"
              >
                <h5 class="primary--text ml-7 mt-n1">
                  <b class="green-text">Setting Alert:</b> You Need to Set Up
                  Few Things Before You Start.

                  <v-btn
                    @click="navigatetocardstocks"
                    small
                    text
                    class="green--text"
                  >
                    <u>Click to start</u>
                  </v-btn>
                </h5>
              </v-alert>
            </v-card>
          </v-col>
        </v-row>

        <v-row style="margin-top: 50px" class="ml-3 mt-10">
          <v-col cols="12" lg="6" sm="12" md="6" xs="12" xl="6">
            <v-card elevation="1" height="510" width="880" shaped class="mr-1">
              <v-tabs
                fixed-tabs
                background-color="white"
                v-model="tab"
                color="black"
              >
                <v-tab
                  v-for="tabname in tabnames"
                  :key="tabname"
                  @click="tabval(tabname)"
                >
                  {{ tabname }}</v-tab
                >
              </v-tabs>
              <v-divider> </v-divider>
              <v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    md="9"
                    lg="9"
                    xl="9"
                    style="margin-left: 90px"
                    class="mt-2"
                    v-if="tab != 0"
                  >
                    <v-tabs
                      fixed-tabs
                      background-color="grey"
                      v-model="tabnew"
                      active-class="primary"
                      color="primary"
                      height="28px"
                      width="400"
                      class="mt-3"
                      dark
                      v-if="
                        tab == 1 &&
                        this.routerLineChartDataNew.datasets[0].data != ''
                      "
                    >
                      <v-tab
                        v-for="tabnewname in tabnewnames"
                        :key="tabnewname"
                        style="color: white"
                        @click="tabvalues(tabnewname)"
                      >
                        {{ tabnewname }}</v-tab
                      >
                    </v-tabs>
                  </v-col>
                </v-row>
                <v-row v-if="tab == 0" style="margin-left: 30px">
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    md="7"
                    lg="7"
                    xl="7"
                    v-if="tab == 0"
                  >
                    <div>
                      <v-card width="450" height="auto" class="mt-2" flat>
                        <PieChart
                          :chartdata="PieChartData"
                          :options="optionsgraph"
                          :width="200"
                          :height="200"
                        />
                      </v-card>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    md="5"
                    lg="5"
                    xl="5"
                    style="margin-top: 80px; margin-left: -20px"
                  >
                    <v-card style="margin-top: -60px" width="250px">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          xs="12"
                          md="12"
                          lg="12"
                          xl="12"
                        >
                          <v-btn
                            text
                            small
                            class="black--text mt-2"
                            @click="count = 2"
                          >
                            <v-icon x-small color="#ffa600"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              >Assigned Cards :
                              <b>{{
                                this.piechartarray.assigned_card_count
                              }}</b></span
                            ><br />
                          </v-btn>
                          <v-btn
                            text
                            small
                            class="black--text mt-2"
                            @click="count = 3"
                          >
                            <v-icon x-small color="#ff6361"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              >Active Card USers :
                              <b>{{
                                this.piechartarray.active_users_count
                              }}</b></span
                            ><br />
                          </v-btn>
                          <v-btn text small class="black--text mt-2">
                            <v-icon x-small color="#003f5c"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span span class="ml-1"
                              >Unassigned Cards :
                              <b>{{
                                this.piechartarray.unassigned_card_count
                              }}</b></span
                            ><br />
                          </v-btn>
                          <v-btn text small class="black--text mt-2">
                            <v-icon x-small color="black"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              >Total Cards :
                              <b>{{ this.newpiechartArray }}</b></span
                            ><br />
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row style="margin-left: 0px">
                  <v-col cols="12" sm="12" xs="12" md="7" lg="7" xl="7">
                    <div>
                      <v-card
                        width="450"
                        height="auto"
                        class="mt-2"
                        flat
                        v-if="
                          tab == 1 &&
                          this.routerLineChartDataNew.datasets[0].data != ''
                        "
                      >
                        <PieChart
                          :chartdata="routerLineChartDataNew"
                          :options="routerLineChartOptionsLine"
                          :width="250"
                          :height="350"
                          v-if="renderComponent2"
                        />
                      </v-card>
                      <!-- <div style="margin-top:180px">
                      <span  class="black--text ml-n16"  v-if="tab == 1 && this.routerLineChartDataNew.datasets[0]
                                    .data ==''" 
                                    >No Data Available</span>
                                    </div> -->
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    xs="12"
                    md="5"
                    lg="5"
                    xl="5"
                    style="margin-top: 80px; margin-left: -20px"
                  >
                    <v-card
                      style="margin-top: -60px"
                      width="250px"
                      height="auto"
                      v-if="
                        tab == 1 &&
                        this.routerLineChartDataNew.datasets[0].data != ''
                      "
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          xs="12"
                          md="12"
                          lg="12"
                          xl="12"
                        >
                          <v-btn
                            text
                            small
                            class="black--text"
                            v-if="this.routerLineChartDataNew.labels[0]"
                            @click="DataTable(CatId)"
                          >
                            <v-icon x-small color="#34495e"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              ><b
                                >{{ this.routerLineChartDataNew.labels[0] }} :
                                {{
                                  this.routerLineChartDataNew.datasets[0]
                                    .data[0]
                                }}
                              </b></span
                            ><br />
                          </v-btn>
                          <br />
                          <v-btn
                            text
                            small
                            class="black--text mt-2"
                            v-if="this.routerLineChartDataNew.labels[1]"
                            @click="DataTable2(CatId2)"
                          >
                            <v-icon x-small color="#839192"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              ><b
                                >{{ this.routerLineChartDataNew.labels[1] }} :
                                {{
                                  this.routerLineChartDataNew.datasets[0]
                                    .data[1]
                                }}
                              </b></span
                            ><br />
                          </v-btn>
                          <br />
                          <v-btn
                            text
                            small
                            class="black--text mt-2"
                            v-if="this.routerLineChartDataNew.labels[2]"
                            @click="DataTable3(CatId3)"
                          >
                            <v-icon x-small color="#9a7d0a"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              ><b
                                >{{ this.routerLineChartDataNew.labels[2] }} :
                                {{
                                  this.routerLineChartDataNew.datasets[0]
                                    .data[2]
                                }}
                              </b></span
                            ><br />
                          </v-btn>
                          <br />
                          <v-btn
                            text
                            small
                            class="black--text mt-2"
                            v-if="this.routerLineChartDataNew.labels[3]"
                            @click="DataTable4(CatId4)"
                          >
                            <v-icon x-small color="#17a589"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              ><b
                                >{{ this.routerLineChartDataNew.labels[3] }} :
                                {{
                                  this.routerLineChartDataNew.datasets[0]
                                    .data[3]
                                }}</b
                              ></span
                            ><br />
                          </v-btn>
                          <br />
                          <v-btn
                            text
                            small
                            class="black--text mt-2"
                            v-if="this.routerLineChartDataNew.labels[4]"
                            @click="DataTable5(CatId5)"
                          >
                            <v-icon x-small color="#7b241c"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <span class="ml-1"
                              ><b
                                >{{ this.routerLineChartDataNew.labels[4] }} :
                                {{
                                  this.routerLineChartDataNew.datasets[0]
                                    .data[4]
                                }}</b
                              ></span
                            ><br />
                          </v-btn>
                          <br />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            style="margin-left: -20px"
            v-if="tab == 0"
          >
            <v-row>
              <v-col cols="12" lg="12" sm="12" md="12" xs="12" xl="12">
                <v-card
                  width="auto"
                  height="510px"
                  class="ml-2 mt-2"
                  elevation="1"
                  shaped
                >
                  <v-card-subtitle class="body-1 mt-n2">
                    <b>
                      Corporate Balance :

                      <span class="primary--text">
                        MYR
                        {{
                          $store.getters.get_getCustDetails.funding_balance
                        }}</span
                      ></b
                    >
                  </v-card-subtitle>
                  <v-card-actions>
                    <v-row style="margin-left: 130px">
                      <v-col cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
                        <v-btn
                          outlined
                          text
                          small
                          @click="Subscriptionpage()"
                          style="border: solid 1px rgba(165, 126, 60, 1)"
                          class="black--text elevation-3"
                        >
                          <v-icon small>mdi-card-plus </v-icon>
                          <span class="ml-3 mr-4"> Manage Cards</span>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                        <v-btn
                          outlined
                          text
                          small
                          @click="Employeespage()"
                          style="border: solid 1px rgba(165, 126, 60, 1)"
                          class="black--text elevation-4"
                        >
                          <v-icon class="ml-0" small>mdi-account-group </v-icon>
                          <span class="mr-1 ml-3">Glyd Card Users</span>
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
                        <v-btn
                          outlined
                          text
                          small
                          @click="corporateLoadfunds()"
                          style="border: solid 1px rgba(165, 126, 60, 1)"
                          class="black--text elevation-4"
                        >
                          <v-icon class="ml-0" small>mdi-cash-multiple </v-icon>
                          <span class="mr-0 ml-3">Load Corp Funds</span>
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
                        <v-btn
                          outlined
                          text
                          small
                          @click="cardLoadfunds()"
                          style="border: solid 1px rgba(165, 126, 60, 1)"
                          class="black--text elevation-4"
                        >
                          <v-icon class="ml-0" small>mdi-cash-multiple </v-icon>
                          <span class="mr-0 ml-3">Load Card Funds</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>

                  <v-divider class="mt-3"></v-divider>
                  <div>
                    <v-card
                      flat
                      v-if="
                        count != '2' &&
                        count != '3' &&
                        count != '4' &&
                        count == '1'
                      "
                    >
                      <v-card-subtitle class="body-1 mt-4" color="#ECEFF1">
                        <b>Card Transactions</b>

                        <v-btn
                          @click="back"
                          style="
                            font-style: italic;
                            font-family: Times New Roman;
                          "
                          class="text-left primary--text ml-n3 mt-n0"
                          text
                        >
                          <v-icon class="grey--text"
                            >mdi-arrow-right</v-icon
                          ></v-btn
                        >
                      </v-card-subtitle>

                      <v-data-table
                        :headers="headers"
                        :items="cardtransactions"
                        dense
                        @click:row="transrow()"
                        hide-default-footer
                        :search="search"
                        item-key="name"
                        class="mt-n3"
                      >
                        <template v-slot:[`item.sl_no`]="{ item }">
                          <span class="caption">{{
                            cardtransactions.indexOf(item) + 1
                          }}</span>
                        </template>
                        <template v-slot:[`item.txn_description`]="{ item }">
                          <span class="caption">{{
                            item.txn_description
                          }}</span>
                        </template>
                        <template v-slot:[`item.merchant_name`]="{ item }">
                          <span class="caption">{{ item.merchant_name }}</span>
                        </template>
                        <template v-slot:[`item.txn_type`]="{ item }">
                          <!-- <span
                            class="caption"
                            v-if="item.txn_type == 'WALLET_DEBIT'"
                            >Wallet Debit
                          </span> -->
                          <!-- <span
                            class="caption"
                            v-if="item.txn_type"
                            >Ecom Purchase
                          </span> -->
                          <span class="caption">{{ item.txn_type }}</span>
                        <br />
                          <span class="caption">{{ item.txn_timestamp }}</span>
                        </template>
                        <template v-slot:[`item.txn_amount`]="{ item }">
                          <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                          <span class="caption">{{ item.txn_currency }}</span>
                          &nbsp;
                          <span
                            class="caption red--text"
                            v-if="item.type == 'DEBIT' || item.type == 'D'"
                            >- {{ item.txn_amount }}
                          </span>
                          <!-- <span
                            class="caption red--text"
                            v-if="item.txn_type == 'CASH_WITHDRAWAL'"
                            >- {{ item.txn_amount }}
                          </span> -->
                          <span
                            class="caption green--text"
                            v-if="item.type == 'CREDIT' || item.type == 'C'"
                            >+ {{ item.txn_amount }}
                          </span>
                          <!-- <span
                            class="caption red--text"
                            v-if="item.txn_type == 'PURCHASE'"
                            >- {{ item.txn_amount }}
                          </span> -->
                        </template>
                        <template v-slot:[`item.billing_amount`]="{ item }">
                          <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                          <div v-if="item.billing_amount != null">
                            <span
                              class="caption red--text"
                              v-if="item.type == 'DEBIT' || item.type == 'D'"
                              >- {{ item.billing_amount }}
                            </span>

                            <span
                              class="caption green--text"
                              v-if="item.type == 'CREDIT' || item.type == 'C'"
                              >+ {{ item.billing_amount }}
                            </span>
                          </div>
                          <div v-else>-</div>
                        </template>
                        <template v-slot:[`item.txn_currency`]="{ item }">
                          <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                          <div v-if="item.txn_currency != null">
                            <span class="caption"
                              >{{ item.txn_currency }}
                            </span>
                          </div>
                          <div v-else>-</div>
                        </template>
                        <template v-slot:[`item.txn_timestamp`]="{ item }">
                          <span
                            class="caption"
                            v-if="item.txn_timestamp != null"
                          >
                            {{ item.txn_timestamp }}
                          </span>
                        </template>
                        <template v-slot:[`item.created_on`]="{ item }">
                          <span class="caption">{{ item.created_on }}</span>
                        </template>
                        <template v-slot:[`item.account_balance`]="{ item }">
                          <span class="caption">{{
                            item.account_balance
                          }}</span>
                        </template>
                        <template v-slot:[`item.user_name`]="{ item }">
                          <span class="caption">{{ item.user_name }}</span
                          ><br />
                          <span class="caption">{{ item.mobile_number }}</span>
                          <span class="caption" v-if="item.user_name == null"
                            >-</span
                          ><br />
                        </template>
                        <template v-slot:[`item.View`]="{ item }">
                          <span>
                            <v-icon
                              small
                              class="ml-2"
                              @click="showContent(item)"
                              v-on="on"
                              color="primary"
                              >mdi-eye</v-icon
                            ></span
                          >
                        </template>
                      </v-data-table>
                    </v-card>
                  </div>
                  <div>
                    <v-card flat v-if="count == '3' && this.tab == 0">
                      <v-card-title class="body-1 mt-4" color="#ECEFF1">
                        <b>Active Card Users</b>
                      </v-card-title>
                      <v-divider class="mt-3"> </v-divider>
                      <v-data-table
                        :headers="headersNew"
                        :items="Tabledata"
                        dense
                        class="mt-n3"
                        :items-per-page="5"
                      >
                        <template v-slot:[`item.sl_no`]="{ item }">
                          <span class="caption">{{
                            Tabledata.indexOf(item) + 1
                          }}</span>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                          <span class="caption"
                            ><b>{{ item.name }}</b></span
                          >
                        </template>
                        <template v-slot:[`item.mobile_no`]="{ item }">
                          <span class="caption">{{ item.mobile_no }}</span>
                        </template>
                        <template v-slot:[`item.email_id`]="{ item }">
                          <span class="caption">{{ item.email_id }}</span>
                        </template>
                      </v-data-table>
                    </v-card>
                  </div>
                  <div>
                    <v-card flat v-if="count == '4' && this.tab == 1">
                      <v-card-title class="body-1 mt-4" color="#ECEFF1">
                        <b>Expense Category Details</b>
                      </v-card-title>
                      <v-data-table
                        v-if="tab == 1"
                        fixed-header
                        :headers="headers3"
                        :items="chart_dataNew"
                        dense
                        hide-default-footer
                        flat
                      >
                        <template v-slot:[`item.sl_no`]="{ item }">
                          <span class="caption">{{
                            chart_dataNew.indexOf(item) + 1
                          }}</span>
                        </template>
                        <template v-slot:[`item.overall_expense`]="{ item }">
                          <b>{{ item.overall_expense }}</b>
                        </template>
                      </v-data-table>
                    </v-card>
                  </div>
                  <div>
                    <v-card flat v-if="count == '2' && tab == 0">
                      <v-card-title class="body-1 mt-4" color="#ECEFF1">
                        <b>Assigned Card Users</b>
                      </v-card-title>
                      <v-divider class="mt-3"> </v-divider>
                      <v-data-table
                        :headers="headersNew2"
                        :items="Tabledata2"
                        dense
                        class="mt-n3"
                        :items-per-page="5"
                      >
                        <template v-slot:[`item.sl_no`]="{ item }">
                          <span class="caption">{{
                            Tabledata2.indexOf(item) + 1
                          }}</span>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                          <span class="caption"
                            ><b>{{ item.name }}</b></span
                          >
                        </template>
                        <template v-slot:[`item.mobile_no`]="{ item }">
                          <span class="caption">{{ item.mobile_no }}</span>
                        </template>
                        <template v-slot:[`item.email_id`]="{ item }">
                          <span class="caption">{{ item.email_id }}</span>
                        </template>
                      </v-data-table>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 5 && tab == 1 && statusMsg != 'No Record Found'"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <v-card-title class="body-1" color="#ECEFF1">
                <b>Category Details</b>
              </v-card-title>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div>
                    <v-data-table
                      :headers="headersChart1"
                      :items="chart_data1"
                      dense
                      :search="search"
                      class="mt-3"
                      hide-default-footer
                    >
                      <template v-slot:[`item.sl_no`]="{ item }">
                        <span class="caption">{{
                          chart_data1.indexOf(item) + 1
                        }}</span>
                      </template>
                      <template v-slot:[`item.cat_name`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.cat_name }}</b></span
                        >
                      </template>
                      <template v-slot:[`item.dep_name`]="{ item }">
                        <span class="caption">{{ item.dep_name }}</span>
                      </template>
                      <template v-slot:[`item.user_name`]="{ item }">
                        <span class="caption">{{ item.user_name }}</span>
                      </template>
                      <template v-slot:[`item.approved_amt`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.approved_amt }}</b></span
                        >
                      </template>
                    </v-data-table>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click="charts1()"
                        class="black--text elevation-6 mt-3 mr-7"
                        small
                        color="#ECEFF1"
                        style="border: solid 1px rgba(165, 126, 60, 1)"
                      >
                        More Charts
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="statusMsg == 'No Record Found' && tab == 1"
            style="margin-left: -20px"
          >
            <v-card width="auto" height="510px" class="ml-2" flat>
              <v-row align="center" justify="center" style="margin-top: 200px">
                <marquee direction="left">
                  <span style="font-size: 25px"><b>NO DATA AVAILABLE</b></span>
                </marquee>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 6 && tab == 1 && statusMsg != 'No Record Found'"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <v-card-title class="body-1" color="#ECEFF1">
                <b>Category Details</b>
              </v-card-title>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div>
                    <v-data-table
                      :headers="headersChart2"
                      :items="chart_data2"
                      dense
                      :search="search"
                      class="mt-3"
                      hide-default-footer
                    >
                      <template v-slot:[`item.sl_no`]="{ item }">
                        <span class="caption">{{
                          chart_data2.indexOf(item) + 1
                        }}</span>
                      </template>
                      <template v-slot:[`item.cat_name`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.cat_name }}</b></span
                        >
                      </template>
                      <template v-slot:[`item.dep_name`]="{ item }">
                        <span class="caption">{{ item.dep_name }}</span>
                      </template>
                      <template v-slot:[`item.user_name`]="{ item }">
                        <span class="caption">{{ item.user_name }}</span>
                      </template>
                      <template v-slot:[`item.approved_amt`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.approved_amt }}</b></span
                        >
                      </template>
                    </v-data-table>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click="charts2()"
                        class="black--text elevation-6 mt-3 mr-7"
                        small
                        color="#ECEFF1"
                        style="border: solid 1px rgba(165, 126, 60, 1)"
                      >
                        More Charts
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 7 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <v-card-title class="body-1" color="#ECEFF1">
                <b>Category Details</b>
              </v-card-title>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div>
                    <v-data-table
                      :headers="headersChart3"
                      :items="chart_data3"
                      dense
                      :search="search"
                      class="mt-3"
                      hide-default-footer
                    >
                      <template v-slot:[`item.sl_no`]="{ item }">
                        <span class="caption">{{
                          chart_data3.indexOf(item) + 1
                        }}</span>
                      </template>
                      <template v-slot:[`item.cat_name`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.cat_name }}</b></span
                        >
                      </template>
                      <template v-slot:[`item.dep_name`]="{ item }">
                        <span class="caption">{{ item.dep_name }}</span>
                      </template>
                      <template v-slot:[`item.user_name`]="{ item }">
                        <span class="caption">{{ item.user_name }}</span>
                      </template>
                      <template v-slot:[`item.approved_amt`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.approved_amt }}</b></span
                        >
                      </template>
                    </v-data-table>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click="charts3()"
                        class="black--text elevation-6 mt-3 mr-7"
                        small
                        color="#ECEFF1"
                        style="border: solid 1px rgba(165, 126, 60, 1)"
                      >
                        More Charts
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 8 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <v-card-title class="body-1" color="#ECEFF1">
                <b>Category Details</b>
              </v-card-title>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div>
                    <v-data-table
                      :headers="headersChart4"
                      :items="chart_data4"
                      dense
                      :search="search"
                      class="mt-3"
                      hide-default-footer
                    >
                      <template v-slot:[`item.sl_no`]="{ item }">
                        <span class="caption">{{
                          chart_data4.indexOf(item) + 1
                        }}</span>
                      </template>
                      <template v-slot:[`item.cat_name`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.cat_name }}</b></span
                        >
                      </template>
                      <template v-slot:[`item.dep_name`]="{ item }">
                        <span class="caption">{{ item.dep_name }}</span>
                      </template>
                      <template v-slot:[`item.user_name`]="{ item }">
                        <span class="caption">{{ item.user_name }}</span>
                      </template>
                      <template v-slot:[`item.approved_amt`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.approved_amt }}</b></span
                        >
                      </template>
                    </v-data-table>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click="charts4()"
                        class="black--text elevation-6 mt-3 mr-7"
                        small
                        color="#ECEFF1"
                        style="border: solid 1px rgba(165, 126, 60, 1)"
                      >
                        More Charts
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 9 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <v-card-title class="body-1" color="#ECEFF1">
                <b>Category Details</b>
              </v-card-title>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div>
                    <v-data-table
                      :headers="headersChart5"
                      :items="chart_data5"
                      dense
                      :search="search"
                      class="mt-3"
                      hide-default-footer
                    >
                      <template v-slot:[`item.sl_no`]="{ item }">
                        <span class="caption">{{
                          chart_data5.indexOf(item) + 1
                        }}</span>
                      </template>
                      <template v-slot:[`item.cat_name`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.cat_name }}</b></span
                        >
                      </template>
                      <template v-slot:[`item.dep_name`]="{ item }">
                        <span class="caption">{{ item.dep_name }}</span>
                      </template>
                      <template v-slot:[`item.user_name`]="{ item }">
                        <span class="caption">{{ item.user_name }}</span>
                      </template>
                      <template v-slot:[`item.approved_amt`]="{ item }">
                        <span class="caption"
                          ><b>{{ item.approved_amt }}</b></span
                        >
                      </template>
                    </v-data-table>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click="charts5()"
                        class="black--text elevation-6 mt-3 mr-7"
                        small
                        color="#ECEFF1"
                        style="border: solid 1px rgba(165, 126, 60, 1)"
                      >
                        More Charts
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 10 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <div>
                <v-row class="mt-0 ml-6">
                  <v-col cols="5" class="mt-0" style="margin-left: 40px">
                    <label class="caption">User Name</label>
                    <v-select
                      v-model="UsrID"
                      label="select here"
                      :items="chart_data1"
                      dense
                      solo
                      item-text="user_name"
                      item-value="user_id"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="5" class="mt-0">
                    <label class="caption">Department Name</label>
                    <v-select
                      v-model="DeprtID"
                      label="select here"
                      :items="chart_data1"
                      dense
                      solo
                      item-text="dep_name"
                      item-value="dep_id"
                    >
                    </v-select>
                  </v-col>

                  <v-col lg="1" class="mt-7">
                    <v-btn
                      x-small
                      fab
                      dark
                      color="primary"
                      class="elevation-0"
                      @click="barchart()"
                    >
                      <v-icon dark>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <BarChart
                  :chartdata="routerLineChartData"
                  :options="routerLineChartOptions"
                  :width="200"
                  :height="300"
                  class="ml-3 mt-5 mr-6"
                  v-if="renderComponent1"
                />
              </div>
              <v-row style="margin-left: 30px">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 11 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <div>
                <v-row class="mt-0 ml-6">
                  <v-col cols="5" class="mt-0" style="margin-left: 40px">
                    <label class="caption">User Name</label>
                    <v-select
                      v-model="UsrID2"
                      label="select here"
                      :items="chart_data2"
                      dense
                      solo
                      item-text="user_name"
                      item-value="user_id"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="5" class="mt-0">
                    <label class="caption">Department Name</label>
                    <v-select
                      v-model="DeprtID2"
                      label="select here"
                      :items="chart_data2"
                      dense
                      solo
                      item-text="dep_name"
                      item-value="dep_id"
                    >
                    </v-select>
                  </v-col>

                  <v-col lg="1" class="mt-7">
                    <v-btn
                      x-small
                      fab
                      dark
                      color="primary"
                      class="elevation-0"
                      @click="barchart2()"
                    >
                      <v-icon dark>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <BarChart
                  :chartdata="routerLineChartData2"
                  :options="routerLineChartOptions"
                  :width="200"
                  :height="300"
                  class="ml-3 mt-5 mr-6"
                  v-if="renderComponent1"
                />
              </div>
              <v-row style="margin-left: 30px">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 12 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <div>
                <v-row class="mt-0 ml-6">
                  <v-col cols="5" class="mt-0" style="margin-left: 40px">
                    <label class="caption">User Name</label>
                    <v-select
                      v-model="UsrID3"
                      label="select here"
                      :items="chart_data3"
                      dense
                      solo
                      item-text="user_name"
                      item-value="user_id"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="5" class="mt-0">
                    <label class="caption">Department Name</label>
                    <v-select
                      v-model="DeprtID3"
                      label="select here"
                      :items="chart_data3"
                      dense
                      solo
                      item-text="dep_name"
                      item-value="dep_id"
                    >
                    </v-select>
                  </v-col>

                  <v-col lg="1" class="mt-7">
                    <v-btn
                      x-small
                      fab
                      dark
                      color="primary"
                      class="elevation-0"
                      @click="barchart3()"
                    >
                      <v-icon dark>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <BarChart
                  :chartdata="routerLineChartData3"
                  :options="routerLineChartOptions"
                  :width="200"
                  :height="300"
                  class="ml-3 mt-5 mr-6"
                  v-if="renderComponent1"
                />
              </div>
              <v-row style="margin-left: 30px">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 13 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <div>
                <v-row class="mt-0 ml-6">
                  <v-col cols="5" class="mt-0" style="margin-left: 40px">
                    <label class="caption">User Name</label>
                    <v-select
                      v-model="UsrID4"
                      label="select here"
                      :items="chart_data4"
                      dense
                      solo
                      item-text="user_name"
                      item-value="user_id"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="5" class="mt-0">
                    <label class="caption">Department Name</label>

                    <v-select
                      v-model="DeprtID4"
                      label="select here"
                      :items="chart_data4"
                      dense
                      solo
                      item-text="dep_name"
                      item-value="dep_id"
                    >
                    </v-select>
                  </v-col>

                  <v-col lg="1" class="mt-7">
                    <v-btn
                      x-small
                      fab
                      dark
                      color="primary"
                      class="elevation-0"
                      @click="barchart4()"
                    >
                      <v-icon dark>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <BarChart
                  :chartdata="routerLineChartData4"
                  :options="routerLineChartOptions"
                  :width="200"
                  :height="300"
                  class="ml-3 mt-5 mr-6"
                  v-if="renderComponent1"
                />
              </div>
              <v-row style="margin-left: 30px">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            sm="12"
            md="6"
            xs="12"
            xl="6"
            v-if="count == 14 && tab == 1"
            style="margin-left: -20px"
          >
            <v-card
              width="auto"
              height="510px"
              class="ml-2"
              elevation="1"
              shaped
            >
              <div>
                <v-row class="mt-0 ml-6">
                  <v-col cols="5" class="mt-0" style="margin-left: 40px">
                    <label class="caption">User Name</label>
                    <v-select
                      v-model="UsrID5"
                      label="select here"
                      :items="chart_data5"
                      dense
                      solo
                      item-text="user_name"
                      item-value="user_id"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="5" class="mt-0">
                    <label class="caption">Department Name</label>

                    <v-select
                      v-model="DeprtID5"
                      label="select here"
                      :items="chart_data5"
                      dense
                      solo
                      item-text="dep_name"
                      item-value="dep_id"
                    >
                    </v-select>
                  </v-col>

                  <v-col lg="1" class="mt-7">
                    <v-btn
                      x-small
                      fab
                      dark
                      color="primary"
                      class="elevation-0"
                      @click="barchart5()"
                    >
                      <v-icon dark>mdi-filter</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <BarChart
                  :chartdata="routerLineChartData5"
                  :options="routerLineChartOptions"
                  :width="200"
                  :height="300"
                  class="ml-3 mt-5 mr-6"
                  v-if="renderComponent1"
                />
              </div>
              <v-row style="margin-left: 30px">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <div></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-dialog v-model="dialog" height="900" width="700" persistent>
      <v-card class="overflow-hidden">
        <v-card-title class="primary--text text-h5">
          WELCOME TO GLYD<br />
        </v-card-title>

        <v-card-text
          style="
            font-style: normal;
            font-size: 15px;
            font-family: Times New Roman;
          "
          class="font-weight-light black--text"
        >
          Dear
          {{
            this.$store.getters.get_getCustDetails.user_name
          }},<br />Congratulations! You have successfully registered your
          company with Glyd. You are now one step away from getting Glyd
          Corporate Cards for your company. Click on "Continue" to subscribe to
          a Glyd package.
        </v-card-text>

        <v-card-actions>
          <v-row class="mt-n10">
            <v-col cols="12" md="4">
              <v-img
                src="@/assets/glyd1.svg"
                width="120px"
                max-height="80px"
              ></v-img
            ></v-col>
            <v-col cols="12" md="5"></v-col>
            <v-col cols="12" md="2" class="mt-5">
              <v-btn color="primary " text @click="navigatetocardstock">
                Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog1" height="900" width="750" persistent>
      <v-card class="overflow-hidden">
        <v-card-title class="primary--text text-h5">
          WELCOME TO GLYD<br />
        </v-card-title>

        <v-card-text
          style="
            font-style: normal;
            font-size: 15px;
            font-family: Times New Roman;
          "
          class="font-weight-light black--text"
        >
          Dear
          {{
            this.$store.getters.get_getCustDetails.user_name
          }},<br />Congratulations! You have successfully Purchased Glyd Card
          package. Click on "Continue" to start using Glyd Cards.
        </v-card-text>

        <v-card-actions>
          <v-row class="mt-n10">
            <v-col cols="12" md="4">
              <v-img
                src="@/assets/glyd1.svg"
                width="120px"
                max-height="80px"
              ></v-img
            ></v-col>
            <v-col cols="12" md="5"></v-col>
            <v-col cols="12" md="2" class="mt-5">
              <v-btn
                color="primary "
                text
                @click="
                  dialog_count = 1;
                  dialog1 = false;
                "
              >
                Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
import PieChart from "@/components/Charts/piechart.js";
import BarChart from "@/components/Charts/BarChart.js";

// import PolarArea from "@/components/Charts/PolarArea.js";
import moment from "moment";
import Chart from "chart.js";

export default {
  components: {
    PieChart,
    BarChart,
    // PolarArea,
  },

  data: () => ({
    renderComponent1: true,
    start_date: null,
    end_date: null,

    modalEnd: false,

    modalStart: false,

    renderComponent2: true,
    renderComponent: true,
    // renderComponent1: true,
    // renderComponent3: true,
    // getUser: [],
    DepartId: [],
    deptId: "",
    UserId: "",
    depart_id: "",
    userId: "",
    dateformat: "",
    start_date1: null,
    end_date1: null,
    modalEnd1: false,
    modalStart1: false,

    totalcount: "",
    activeuserCount: "",
    nonactiveuserCount: "",
    totalCard: "",
    count: 1,
    value1: [],
    data1: [],
    data2: [],
    label1: [],
    label2: [],
    activecardcount: 0,
    responsedataaa: [],
    storeResult: [],
    datacollection: {
      labels: [],
      datasets: [],
      name: "",
      val: "",
    },

    details: [
      {
        name: "",
        val: "",
      },
    ],
    btn: "",
    search: "",
    dialog1: false,
    tabnames: ["Card Users", "Exp Category"],
    tabnewnames: ["Last 30 days", "Last 60 days", "Last 90 days"],
    tab: 0,
    tabnew: 0,
    PieChartData: {
      labels: ["Assigned Cards", "Unassigned Cards", "Active Card Users"],

      datasets: [
        {
          data: [],

          backgroundColor: ["#ffa600", "#003f5c", "#ff6361"],
        },
      ],
      // hoverOffset: 4,
    },
    headersChart1: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
      },
      {
        text: "CATEGORY NAME",
        value: "cat_name",

        sortable: false,
      },

      {
        text: "DEPARTMENT NAME",
        value: "dep_name",

        sortable: false,
      },
      {
        text: "USER NAME",
        value: "user_name",

        sortable: false,
      },
      {
        text: "APPROVED AMOUNT",
        value: "approved_amt",

        sortable: false,
      },
    ],
    headersChart2: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
      },
      {
        text: "CATEGORY NAME",
        value: "cat_name",

        sortable: false,
      },

      {
        text: "DEPARTMENT NAME",
        value: "dep_name",

        sortable: false,
      },
      {
        text: "USER NAME",
        value: "user_name",

        sortable: false,
      },
      {
        text: "APPROVED AMOUNT",
        value: "approved_amt",

        sortable: false,
      },
    ],
    headersChart3: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
      },
      {
        text: "CATEGORY NAME",
        value: "cat_name",

        sortable: false,
      },

      {
        text: "DEPARTMENT NAME",
        value: "dep_name",

        sortable: false,
      },
      {
        text: "USER NAME",
        value: "user_name",

        sortable: false,
      },
      {
        text: "APPROVED AMOUNT",
        value: "approved_amt",

        sortable: false,
      },
    ],
    headersChart4: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
      },
      {
        text: "CATEGORY NAME",
        value: "cat_name",

        sortable: false,
      },

      {
        text: "DEPARTMENT NAME",
        value: "dep_name",

        sortable: false,
      },
      {
        text: "USER NAME",
        value: "user_name",

        sortable: false,
      },
      {
        text: "APPROVED AMOUNT",
        value: "approved_amt",

        sortable: false,
      },
    ],
    headersChart5: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
      },
      {
        text: "CATEGORY NAME",
        value: "cat_name",

        sortable: false,
      },

      {
        text: "DEPARTMENT NAME",
        value: "dep_name",

        sortable: false,
      },
      {
        text: "USER NAME",
        value: "user_name",

        sortable: false,
      },
      {
        text: "APPROVED AMOUNT",
        value: "approved_amt",

        sortable: false,
      },
    ],
    headers: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
      },
      {
        text: "USER NAME",
        value: "user_name",
   
        sortable: false,
      },
      {
        text: "TXN TYPE",
        value: "txn_type",

        sortable: false,
      },
      {
        text: "TXN AMT",
        value: "txn_amount",
        align: "start",

        sortable: false,
      },
      // {
      //   text: "TXN CCY",
      //   value: "txn_currency",
      //   align: "start",
      //   width: "2px",

      //   sortable: false,
      // },
      {
        text: "BILLING AMT(MYR)",
        value: "billing_amount",
        align: "start",

        sortable: false,
      },

      // {
      //   text: " TXN ON",
      //   value: "txn_timestamp",
      //   align: "start",

      //   sortable: false,
      //   width: "3px",
      // },
    ],
    headers2: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "User Name",
        value: "user_name",
        align: "start",
        width: "1px",

        sortable: false,
      },
      {
        text: "Total Expense",
        value: "total_expense",
        width: "1px",
        sortable: false,
      },
      {
        text: "Txn Date",
        value: "txn_date",
        width: "1px",

        sortable: false,
      },
      {
        text: "Corp Balance",
        value: "corp_balance",
        width: "1px",

        sortable: false,
      },

      {
        text: " Cardb Balance",
        value: "card_bal",
        align: "start",

        sortable: false,
        width: "1px",
      },
    ],
    headersNew: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "User Name",
        value: "name",
        align: "start",
        width: "1px",

        sortable: false,
      },
      {
        text: "Contact Number",
        value: "mobile_no",
        width: "1px",
        sortable: false,
      },
      {
        text: "Email-Id",
        value: "email_id",
        width: "1px",

        sortable: false,
      },
    ],
    headersNew2: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "User Name",
        value: "name",
        align: "start",
        width: "1px",

        sortable: false,
      },
      {
        text: "Contact Number",
        value: "mobile_no",
        width: "1px",
        sortable: false,
      },
      {
        text: "Email-Id",
        value: "email_id",
        width: "1px",

        sortable: false,
      },
    ],
    category: "",
    categoryItems: [],
    cardtransactions: [],

    optionsgraph: {
      // responsive: true,
      //  maintainAspectRatio: false,

      layout: {
        padding: 20,
      },
      title: {
        display: true,
        // maintainAspectRatio: false,
        text: "Card Users",

        fontSize: 16,
        fontColor: "#6b7280",
        backgroundColor: ["#17BF62"],
      },
      legend: {
        display: true,

        labels: {
          usePointStyle: true,
        },
      },
    },
    startdate: "",
    enddate: "",
    showChart: false,
    departmentClick: false,
    card: false,
    alert: true,
    countDialog: 0,
    dialog: false,
    dialog_count: 0,
    chartEvents: {
      select: () => {
        const PieChart = this.$refs.gChart.chartObject;
        const selection = PieChart.getSelection();
        selection.length !== 0;
      },
      select1: (click) => {
        const myChart = new Chart(document.getElementById("myChart"));
        const points = myChart.getElementAtEventForMode(
          click,
          "nearest",
          { intersect: true },
          true
        );
        console.warn(points);
      },
    },
    catpiechartArray: [],

    timelineitems: [
      {
        color: "primary lighten-2",
        btncolor: "primary lighten-2",
        icon: "mdi-book-variant",
        label: "Step 1(Create Department)",
        message:
          "You need to create departments so that card users belong to the correct   department. This will help you to create department wise Approvers as well as budgets. ",
        btntext: "(click here to create department)",
      },
      {
        color: "primary lighten-2",
        btncolor: "primary lighten-2",
        icon: "mdi-account-plus",
        label: "Step 2(Create Approver)",
        message:
          "You need to create Approvers before you assign cards to the users.  Approvers, as the name suggests, approve the submitted expenses.",
        btntext: "(Click here to create Approver) ",
      },
    ],

    chart_data1: [],
    chart_data2: [],
    chart_data3: [],
    chart_data4: [],
    chart_data5: [],
    Tabledata: [],
    Tabledata2: [],
    CatId: "",
    CatId2: "",
    CatId3: "",
    CatId4: "",
    CatId5: "",
    UsrID: "",
    UsrID2: "",
    UsrID3: "",
    UsrID4: "",
    UsrID5: "",
    DeprtID: "",
    DeprtID2: "",
    DeprtID3: "",
    DeprtID4: "",
    DeprtID5: "",
    routerLineChartDataNew: {
      labels: [],

      datasets: [
        {
          data: [],

          lineThickness: 350,
          backgroundColor: [
            "#34495e",
            "#839192 ",
            "#9a7d0a ",
            "#17a589 ",
            "#7b241c ",
          ],
          // backgroundColor: " #F4511E ",
          fill: false,
        },
      ],
    },
    routerLineChartOptions: {
      scales: {
        yAxes: [
          {
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            },
          },
        ],
      },

      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        title: {
          display: true,
          // maintainAspectRatio: false,
          text: "Total Expense",

          fontSize: 16,
          fontColor: "#17a589",
          backgroundColor: ["#17BF62"],
        },
        // labels: {
        //   usePointStyle: true,
        // },
      },
    },
    routerLineChartOptionsLine: {
      scales: {},
      layout: {
        padding: 20,
      },
      responsive: true,
      maintainAspectRatio: false,

      legend: {
        display: true,
        title: {
          display: true,
          // maintainAspectRatio: false,
          text: "Expense Category",

          fontSize: 16,
          fontColor: "#6b7280",
          backgroundColor: ["#17BF62"],
        },
        labels: {
          usePointStyle: true,
        },
      },
    },
    chart_dataNew: [],
    headers3: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "User Name",
        value: "user_name",
        align: "start",
        width: "1px",

        sortable: false,
      },
      {
        text: "Category Name ",
        value: "cat_name",
        width: "1px",

        sortable: false,
      },
      {
        text: "Overall Expense",
        value: "overall_expense",
        width: "1px",
        sortable: false,
      },
    ],
    routerLineChartData: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Total Expense ",
          barThickness: 70,
          backgroundColor: "#34495e",
          fill: false,
        },
      ],
      chart_dataNew: [],
    },
    routerLineChartData2: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Total Expense ",
          barThickness: 70,
          backgroundColor: "#839192",
          fill: false,
        },
      ],
      chart_dataNew: [],
    },
    routerLineChartData3: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Total Expense ",
          barThickness: 70,
          backgroundColor: "#9a7d0a",
          fill: false,
        },
      ],
      chart_dataNew: [],
    },
    routerLineChartData4: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Total Expense ",
          barThickness: 70,
          backgroundColor: "#17a589",
          fill: false,
        },
      ],
      chart_dataNew: [],
    },
    routerLineChartData5: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Total Expense ",
          barThickness: 70,
          backgroundColor: "#7b241c",
          fill: false,
        },
      ],
      chart_dataNew: [],
    },
    statusMsg: "",
  }),

  // created() {

  // },

  computed: {
    buttonText() {
      return this.selectedFile
        ? this.selectedFile.name
        : this.defaultButtonText;
    },
    auth() {
      return this.$store.getters.get_auth;
    },
  },
  watch: {
    catpiechartArray(val) {
      if (val != []) {
        this.renderComponent2 = false;
        process.nextTick(() => {
          this.renderComponent2 = true;
        });
      }
    },
    chart_dataNew(val) {
      if (val != []) {
        this.renderComponent1 = false;
        process.nextTick(() => {
          this.renderComponent1 = true;
        });
      }
    },
    dialog_count(val) {
      if (val == 1) {
        this.renderComponent = false;
        process.nextTick(() => {
          this.renderComponent = true;
        });
      }
    },
  },
  mounted() {
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.start_date1 = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date1 = new Date().toISOString().substr(0, 10);
    this.ExpCategoryChart();
    this.GetCategory();
    this.getuserdeatils();
    this.piechart();
    // if (this.auth == false) {
    //   this.$router.push("/");
    // }
    // this.getusers();
    this.getdepart();
    this.get_values();
    this.getFundDetails();
  },
  methods: {
    tabval(tab) {
      // console.log("ads",tab)
      if (tab == "Exp Category") {
        this.startdate = moment();
        this.enddate = moment();
        this.startdate = this.startdate.subtract(31, "days");
        this.enddate = this.enddate.subtract(0, "days");
        this.startdate = this.startdate.format("YYYY-MM-DD");
        this.enddate = this.enddate.format("YYYY-MM-DD");
        this.ExpCategoryChart();
        this.count = 0;
      } else if (tab == "Card Users") {
        this.count = 1;
      }
    },
    tabvalues(tab) {
      this.startdate = moment();
      this.enddate = moment();

      if (tab == "Last 30 days") {
        this.startdate = this.startdate.subtract(31, "days");
        this.enddate = this.enddate.subtract(0, "days");
        this.startdate = this.startdate.format("YYYY-MM-DD");
        this.enddate = this.enddate.format("YYYY-MM-DD");
        this.ExpCategoryChart();

        // console.log("this.startdate", this.startdate);
        // console.log("this.enddate", this.enddate);
      } else if (tab == "Last 60 days") {
        this.count = 0;
        this.startdate = this.startdate.subtract(61, "days");
        this.enddate = this.enddate.subtract(0, "days");
        this.startdate = this.startdate.format("YYYY-MM-DD");
        this.enddate = this.enddate.format("YYYY-MM-DD");
        this.ExpCategoryChart();
      } else if (tab == "Last 90 days") {
        this.count = 0;
        this.startdate = this.startdate.subtract(91, "days");
        this.enddate = this.enddate.subtract(0, "days");
        this.startdate = this.startdate.format("YYYY-MM-DD");
        this.enddate = this.enddate.format("YYYY-MM-DD");
        this.ExpCategoryChart();
      }
    },

    handleClick: function () {
      // console.log("event triggered");
    },
    async getFundDetails() {
      var inputData = {
        method_name: "CTRANS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCDTRANS",
          corp_id: this.$store.getters.get_corpid,
          user_id: 0,
          txn_type: 0,
          status: 4,
          search_text: "",
          from_date: null,
          to_date: null,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.cardtransactions = responseData.data.data;
        this.cardtransactions.splice(5);
        // console.log(this.cardtransactions);

        this.overlay = false;
      } else {
        this.overlay = false;
      }
    },

    async get_values() {
      await this.getuserdeatils();
      if (
        this.$store.getters.get_VerificatnStatus == 1 &&
        this.$store.getters.get_display != 2 &&
        this.activecardcount != 0
      ) {
        this.dialog1 = false;
        this.dialog = false;
        this.dialog_count = 1;
        // this.piechart();
      } else if (
        this.$store.getters.get_getCustDetails.is_purchase == 0 &&
        this.$store.getters.get_display != 2
      ) {
        this.dialog1 = false;
        this.dialog = true;
      } else if (
        this.$store.getters.get_getCustDetails.is_purchase != 0 &&
        this.$store.getters.get_display != 2 &&
        this.activecardcount == 0
      ) {
        this.dialog1 = true;
        this.dialog = false;
      } else {
        this.dialog1 = false;
        this.dialog = false;
      }
      this.$store.commit("SET_Department", false);
    },
    back() {
      this.$router.push("/Transactions");
    },
    charts1() {
      this.count = 10;
      this.barchart();
    },
    charts2() {
      this.count = 11;
      this.barchart2();
    },
    charts3() {
      this.count = 12;
      this.barchart3();
    },
    charts4() {
      this.count = 13;
      this.barchart4();
    },
    charts5() {
      this.count = 14;
      this.barchart5();
    },
    transrow() {
      //s console.log("rowval", val);
      this.$router.push("/Transactions");
    },
    Subscriptionpage() {
      this.$router.push("/cardstockmanagement");
    },
    Employeespage() {
      this.$router.push("/Employees");
    },
    corporateLoadfunds() {
      this.$router.push("/corporatefundrequest");
    },
    cardLoadfunds() {
      this.$router.push("/CardBalance");
    },

    close() {
      this.alert = false;
    },
    navigatetocardstocks() {
      this.$router.push("/Timeline");
    },
    next() {
      this.$router.push("/next");
    },
    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        var rowlist = responseData.data.data;
        this.activecardcount = rowlist.active_card_count;
        this.$store.commit("SET_Cusdetails", rowlist);
      }
    },

    async piechart() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CRDUSRCRT",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);

      this.piechartarray = responseData.data.data[0];
      // console.log(" responseData.data.data", responseData.data.data);
      // console.log(" asdas this.chart_data", this.piechartarray);

      this.newpiechartArray = responseData.data.data[0].total_card_count;
      this.Tabledata = responseData.data.data[0].active_users_details;
      this.Tabledata2 = responseData.data.data[0].assigned_card_users_details;
      // console.log("this", this.Tabledata);

      var chartlabels1 = [];

      this.PieChartData.datasets[0].data.push(
        this.piechartarray.assigned_card_count
      );
      // console.log(" this.piechartarray.assigned_card_count", this.piechartarray.assigned_card_count)

      this.PieChartData.datasets[0].data.push(
        this.piechartarray.unassigned_card_count
      );
      this.PieChartData.datasets[0].data.push(
        this.piechartarray.active_users_count
      );

      //this.chartlabels1.push(this.piechartarray.assigned_card_count);

      this.PieChartData.labels = chartlabels1;
    },
    async GetCategory() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCAT",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);

      // console.log("asd",responseData);
      this.categoryItems = responseData.data.data;
    },
    async ExpCategoryChart() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCATE",
          corp_id: this.$store.getters.get_corpid,
          category_id: 0,
          from_date: this.startdate == "" ? null : this.startdate,
          to_date: this.enddate == "" ? null : this.enddate,
          // from_date: null,
          // to_date: null,
        },
      };
      var responseData = await apiCall(inputData);

      this.catpiechartArray =
        responseData.data.data == null ? [] : responseData.data.data;
      this.catpiechartArray.splice(5);
      // console.log(" this.catpiechartArraycvsd",this.catpiechartArray.splice(5));
      if (responseData.data.status == "00") {
        var catTabledata = [];
        var catTabledata1 = [];
        for (let i = 0; i < this.catpiechartArray.length; i++) {
          if (this.catpiechartArray[0]) {
            this.CatId = this.catpiechartArray[0].category_id;
          }
          if (this.catpiechartArray[1]) {
            this.CatId2 = this.catpiechartArray[1].category_id;
          }
          if (this.catpiechartArray[2]) {
            this.CatId3 = this.catpiechartArray[2].category_id;
          }
          if (this.catpiechartArray[3]) {
            this.CatId4 = this.catpiechartArray[3].category_id;
          }
          if (this.catpiechartArray[4]) {
            this.CatId5 = this.catpiechartArray[4].category_id;
          }

          catTabledata.push(this.catpiechartArray[i].overall_expense);
          catTabledata1.push(this.catpiechartArray[i].cat_name);
          // console.log(" this.CatId", this.CatId2);
          // console.log(" catTabledata1", catTabledata1);
        }

        this.routerLineChartDataNew.datasets[0].data = catTabledata;
        this.routerLineChartDataNew.labels = catTabledata1;
        // console.log("sd", this.routerLineChartDataNew.datasets[0].data);
        // console.log("ssdfd", this.routerLineChartDataNew.labels);
      } else if (responseData.data.status == "NOREC") {
        this.statusMsg = responseData.data.status_msg;
      }
    },
    async DataTable() {
      this.count = 5;
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCATD",
          corp_id: this.$store.getters.get_corpid,
          category_id: this.CatId,
          from_date: this.startdate == "" ? null : this.startdate,
          to_date: this.enddate == "" ? null : this.enddate,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log(inputData);
      if (responseData.data.status == "00") {
        this.chart_data1 = responseData.data.data;

        for (let i = 0; i < this.chart_data1.length; i++) {
          this.UsrID = this.chart_data1[i].user_id;
          this.DeprtID = this.chart_data1[i].dep_id;
        }
        this.chart_data1.splice(7);
        this.overlay = false;
      } else if (responseData.data.status == "NOREC") {
        this.statusMsg = responseData.data.status_msg;
      } else {
        this.overlay = false;
      }
    },
    async DataTable2() {
      this.count = 6;
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCATD",
          corp_id: this.$store.getters.get_corpid,
          category_id: this.CatId2,
          from_date: this.startdate == "" ? null : this.startdate,
          to_date: this.enddate == "" ? null : this.enddate,
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.chart_data2 = responseData.data.data;

        for (let i = 0; i < this.chart_data2.length; i++) {
          this.UsrID2 = this.chart_data2[i].user_id;
          this.DeprtID2 = this.chart_data2[i].dep_id;
        }
        this.chart_data2.splice(7);

        this.overlay = false;
      }
    },
    async DataTable3() {
      this.count = 7;
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCATD",
          corp_id: this.$store.getters.get_corpid,
          category_id: this.CatId3,
          from_date: this.startdate == "" ? null : this.startdate,
          to_date: this.enddate == "" ? null : this.enddate,
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.chart_data3 = responseData.data.data;
        for (let i = 0; i < this.chart_data3.length; i++) {
          this.UsrID3 = this.chart_data3[i].user_id;
          this.DeprtID3 = this.chart_data3[i].dep_id;

          // console.log("UsrID3",this.UsrID2)
        }
        this.chart_data3.splice(7);

        // console.log("tv", this.chart_data3);
        this.overlay = false;
      }
    },
    async DataTable4() {
      this.count = 8;
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCATD",
          corp_id: this.$store.getters.get_corpid,
          category_id: this.CatId4,
          from_date: this.startdate == "" ? null : this.startdate,
          to_date: this.enddate == "" ? null : this.enddate,
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.chart_data4 = responseData.data.data;
        for (let i = 0; i < this.chart_data4.length; i++) {
          this.UsrID4 = this.chart_data4[i].user_id;
          this.DeprtID4 = this.chart_data4[i].dep_id;
          // console.log("UsrID4",this.UsrID4)
        }
        this.chart_data4.splice(7);

        // console.log("tv", this.chart_data4);
        this.overlay = false;
      }
    },
    async DataTable5() {
      this.count = 9;
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCATD",
          corp_id: this.$store.getters.get_corpid,
          category_id: this.CatId5,
          from_date: this.startdate == "" ? null : this.startdate,
          to_date: this.enddate == "" ? null : this.enddate,
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.chart_data5 = responseData.data.data;
        for (let i = 0; i < this.chart_data5.length; i++) {
          this.UsrID5 = this.chart_data5[i].user_id;
          this.DeprtID5 = this.chart_data5[i].dep_id;
          // console.log("UsrID5",this.UsrID5)
        }
        this.chart_data5.splice(7);

        // console.log("tv", this.chart_data5);
        this.overlay = false;
      }
    },

    getcal() {
      this.modalStart = true;
    },
    getcal1() {
      this.modalStart1 = true;
    },
    getcal2() {
      this.modalEnd = true;
    },
    getcalnew() {
      this.modalEnd1 = true;
    },
    onButtonClick() {
      this.$refs.uploader.click();
    },
    navigatetocardstock() {
      if (this.$store.getters.get_getCustDetails.is_purchase == 0) {
        this.$router.push("/RequestCard");
      }
      this.dialog = false;
    },
    navigatetodashboard() {
      this.dialog1 = false;
    },

    onFileChanged(e) {
      this.selectedFile = e.target.files[0];

      // do something
    },
    pushToDept() {
      this.$router.push("/Department");
      var roe = true;
      this.$store.commit("SET_Department", roe);
    },

    // async getusers() {
    //   // alert(20);
    //   var inputData = {
    //     method_name: "CHARTS",
    //     page_no: 0,
    //     record_count: 0,
    //     page_size: 25,
    //     app_code: "CPORTAL",
    //     method_param: {
    //       action: "GETAPPUSER",
    //       corp_id: this.$store.getters.get_corpid,
    //     },
    //   };
    //   var responseData = await apiCall(inputData);
    //   this.getUser = responseData.data.data;
    //   // console.log("user",this.getUser)
    //   for (let i = 0; i < this.getUser.length; i++) {
    //     this.UserId = this.getUser[i].user_id;
    //     // console.log("userid",this.UserId)
    //   }
    // },
    async getdepart() {
      // alert(20);
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETDEP",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      this.DepartId = responseData.data.data;
      //  console.log("Depart",this.DepartId);
      for (let i = 0; i < this.DepartId.length; i++) {
        this.deptId = this.DepartId[i].department_id;
        //  console.log("deptId",this.deptId)
      }
    },
    async barchart() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCATCHART",
          corp_id: this.$store.getters.get_corpid,
          from_date: null,
          category_id: this.CatId,
          to_date: null,
          user_id: this.UsrID,
          department_id: this.DeprtID,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.chart_dataNew = responseData.data.data;

        this.overlay = false;
      } else {
        this.chart_dataNew = [];
        this.overlay = false;
      }

      var chartdataitems = [];
      // var chartdataitems0 = [];
      // var chartdataitems1 = [];

      var chartlabels = [];

      for (let i = 0; i < this.chart_dataNew.length; i++) {
        chartdataitems.push(Number(this.chart_dataNew[i].overall_expense));
        // chartdataitems0.push(Number(this.chart_dataNew[i].approved_date));

        chartlabels.push(this.chart_dataNew[i].approved_date);
      }
      this.routerLineChartData.datasets[0].data = chartdataitems;
      // console.log("vtu", this.routerLineChartData.datasets[0].data);
      //       this.routerLineChartData.datasets[1].data = chartdataitems0;
      // console.log("vtxcvxcvu",this.routerLineChartData.datasets[1].data);

      //       this.routerLineChartData.datasets[2].data = chartdataitems1;
      // console.log("vxcgdfgertwerwerwertu",this.routerLineChartData.datasetExpense Categorys[2].data);

      this.routerLineChartData.labels = chartlabels;
      // console.log("uyuyu", this.routerLineChartData.labels);
    },
    async barchart2() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCATCHART",
          corp_id: this.$store.getters.get_corpid,
          from_date: null,
          category_id: this.CatId2,
          to_date: null,
          user_id: this.UsrID2,
          department_id: this.DeprtID2,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.chart_dataNew = responseData.data.data;

        this.overlay = false;
      } else {
        this.chart_dataNew = [];
        this.overlay = false;
      }
      var chartdataitems = [];
      var chartlabels = [];
      for (let i = 0; i < this.chart_dataNew.length; i++) {
        chartdataitems.push(Number(this.chart_dataNew[i].overall_expense));
        chartlabels.push(this.chart_dataNew[i].approved_date);
      }
      this.routerLineChartData2.datasets[0].data = chartdataitems;
      this.routerLineChartData2.labels = chartlabels;
    },
    async barchart3() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCATCHART",
          corp_id: this.$store.getters.get_corpid,
          from_date: null,
          category_id: this.CatId3,
          to_date: null,
          user_id: this.UsrID3,
          department_id: this.DeprtID3,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.chart_dataNew = responseData.data.data;

        this.overlay = false;
      } else {
        this.chart_dataNew = [];
        this.overlay = false;
      }
      var chartdataitems = [];
      var chartlabels = [];
      for (let i = 0; i < this.chart_dataNew.length; i++) {
        chartdataitems.push(Number(this.chart_dataNew[i].overall_expense));
        chartlabels.push(this.chart_dataNew[i].approved_date);
      }
      this.routerLineChartData3.datasets[0].data = chartdataitems;
      this.routerLineChartData3.labels = chartlabels;
    },
    async barchart4() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCATCHART",
          corp_id: this.$store.getters.get_corpid,
          from_date: null,
          category_id: this.CatId4,
          to_date: null,
          user_id: this.UsrID4,
          department_id: this.DeprtID4,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.chart_dataNew = responseData.data.data;

        this.overlay = false;
      } else {
        this.chart_dataNew = [];
        this.overlay = false;
      }
      var chartdataitems = [];
      var chartlabels = [];
      for (let i = 0; i < this.chart_dataNew.length; i++) {
        chartdataitems.push(Number(this.chart_dataNew[i].overall_expense));
        chartlabels.push(this.chart_dataNew[i].approved_date);
      }
      this.routerLineChartData4.datasets[0].data = chartdataitems;
      this.routerLineChartData4.labels = chartlabels;
    },
    async barchart5() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCATCHART",
          corp_id: this.$store.getters.get_corpid,
          from_date: null,
          category_id: this.CatId5,
          to_date: null,
          user_id: this.UsrID5,
          department_id: this.DeprtID5,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.chart_dataNew = responseData.data.data;

        this.overlay = false;
      } else {
        this.chart_dataNew = [];
        this.overlay = false;
      }
      var chartdataitems = [];
      var chartlabels = [];
      for (let i = 0; i < this.chart_dataNew.length; i++) {
        chartdataitems.push(Number(this.chart_dataNew[i].overall_expense));
        chartlabels.push(this.chart_dataNew[i].approved_date);
      }
      this.routerLineChartData5.datasets[0].data = chartdataitems;
      this.routerLineChartData5.labels = chartlabels;
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
